// import the helper dependency
import mixpanel from "mixpanel-browser";
// initalize the helper, inside of the () is the publishable key that tells the mixpanel helper where to send the tracked data
mixpanel.init("c2f1e88e71b447bf187bbe55c12e01af");

export default mixpanel;

